import Scene = Phaser.Scene;
import Sprite = Phaser.GameObjects.Sprite;
import SpriteUtils from "@/utils/sprite-utils";
import {LightIntroPanel} from "@/scenes.ui/light-intro-panel";

export class PromoSoloPanel extends LightIntroPanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, title: string, subtitle: string, atlasKey: string | undefined,
                iconKey: string, blockFirstText: string, blockSecondText: string, onAcceptCallback: () => unknown) {
        super(scene, canvas, title, subtitle, atlasKey, iconKey, blockFirstText, blockSecondText, onAcceptCallback);
    }

    protected afterIconInit(scene: Scene, icon: Sprite) {
        scene.load.image('gems_chest', 'assets/chest/silverChest.png');

        scene.load.once(Phaser.Loader.Events.COMPLETE, () => {
            icon.setTexture('gems_chest');
            SpriteUtils.scale(icon, 0.7);
        });
        scene.load.start();
    }
}
